import { LAYER_TYPES, LAYER_SUBTYPES } from '../../../../api/Layers/Layers';

export default [
  {
    name: 'CSV Example Map',
    url:
      'https://gist.githubusercontent.com/pilarArr/18f8bc010dfd327616413ba75c4de858/raw/69fa68e607cd0662a0e0c4931e6836e637897664/Jucar.csv',
    layerType: LAYER_TYPES.THEMATIC,
    layerSubType: LAYER_SUBTYPES.CSV,
    description: '',
    thematicKeyList: [
      'ID',
      'URL',
      'Video_Time',
      'GNSS_Day',
      'GNSS_Hour',
      'Long_Home',
      'Lat_Home',
      'H_Home',
      'Long_CP',
      'Lat_CP',
      'H_CP',
      'H_PN',
      'Omega_CP',
      'Phi_CP',
      'Kappa_CP',
      'Orientation_CP',
      'long_CPP',
      'Lat_CPP',
      'H_CPP',
      'long_P0',
      'lat_P0',
      'H_P0',
      'long_P1',
      'lat_P1',
      'H_P1',
      'long_P2',
      'lat_P2',
      'H_P2',
      'long_P31',
      'lat_P3',
      'H_P3'
    ]
  },
  {
    name: 'CSV Example For Fusion',
    url: 'https://dl.dropboxusercontent.com/s/hh6tb9r3xwxwclq/csv_spain%20provincies.csv?dl=0',
    layerType: LAYER_TYPES.THEMATIC,
    layerSubType: LAYER_SUBTYPES.CSV,
    description: '',
    thematicKeyList: ['cod_prov', 'name', 'cod_ccaa', 'atributoA', 'atributoB', 'atributoC']
  }
];
